import { render, staticRenderFns } from "./CmsBlock.vue?vue&type=template&id=21585218&scoped=true"
import script from "./CmsBlock.vue?vue&type=script&lang=js"
export * from "./CmsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21585218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21585218')) {
      api.createRecord('21585218', component.options)
    } else {
      api.reload('21585218', component.options)
    }
    module.hot.accept("./CmsBlock.vue?vue&type=template&id=21585218&scoped=true", function () {
      api.rerender('21585218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CmsBlock.vue"
export default component.exports